module.exports = __webpack_public_path__ + "static/img/has-video.20d45108.png";